import { render, staticRenderFns } from "./ExternalLeftRight.vue?vue&type=template&id=b065972e"
import script from "./ExternalLeftRight.vue?vue&type=script&lang=js"
export * from "./ExternalLeftRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports